import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, insideImages } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      setIndex(Math.max(0, Math.min(insideImages.length - 1, i)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-98" data-mp="a2o3oog3rxft">
      <div className="mx-auto max-w-2xl" data-id="element-99" data-mp="a139izxpagih">
        <h2 className="text-center font-display text-[1.55rem] font-extrabold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-100" data-mp="612upe6ow3aw">
          LOOK <span className="text-signal" data-id="element-101" data-mp="jzsskw1c270b">INSIDE</span>
        </h2>
        <p className="mt-1 text-center font-display text-[0.8rem] font-extrabold uppercase text-gold sm:text-[0.95rem]" data-id="element-102" data-mp="f1r7y6o9dzmq">
          See FIBER OPTIC DIAGNOSTIC PRO™ In Action
        </p>
        <p className="mt-1 text-center text-[0.78rem] leading-[1.35] text-white/80 sm:text-[0.9rem]" data-id="element-103" data-mp="3nf7ypm6lbwg6">
          Explore annotated OTDR traces, optical loss worksheets, network diagrams, connector inspection references,
          fault-isolation matrices, FTTH/PON troubleshooting workflows, and professional field diagnostic resources
          included in the system.
        </p>

        <div className="relative mt-2" data-id="element-104" data-mp="34p8i7notfpod">
          <div ref={trackRef} className="flex snap-x snap-mandatory overflow-x-auto rounded-lg border-2 border-signal bg-white [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="group" aria-roledescription="carousel" aria-label="Interior pages of Fiber Optic Diagnostic Pro" tabIndex={0} data-id="element-105" data-mp="2zs9pn9ksvqsa">
            {insideImages.map((img, i) => <a key={img.src} href={PURCHASE_ANCHOR} className="flex w-full shrink-0 snap-center items-center" aria-label={`Page ${i + 1} of ${insideImages.length} — get the complete system`} data-id="element-106" data-mp="1hfgoroemn17a" data-mpi={i}>
                <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto w-full bg-white" data-id="element-107" data-mp="tpmi5okwi8vh" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1.5 top-1/2 -translate-y-1/2 rounded-full border-2 border-signal bg-navy/90 p-1.5 text-signal shadow-md transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-30" data-id="element-108" data-mp="2a4xhyoa2mm4k">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-109" data-mp="26hfq9b9hmfeb" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-full border-2 border-signal bg-navy/90 p-1.5 text-signal shadow-md transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-30" data-id="element-110" data-mp="26fmtqosl9bk1">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-111" data-mp="3ly7wz07wtulm" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-1.5" data-id="element-112" data-mp="3hww1ie2cuf5i">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-[width,background-color] duration-150 ease-out ${i === index ? 'w-5 bg-signal' : 'w-1.5 bg-navy-line'}`} data-id="element-113" data-mp="3ozjc4exkvndk" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}